/**
 * @typedef {"json"} InputType
 * @typedef {"golang" | "jsdoc" | "typescript" | "zod"} Format
 */

export const TARGET_FORMATS = {
    golang: 'golang',
    jsdoc: 'jsdoc',
    typescript: 'typescript',
    zod: 'zod',
};

export const INPUT_TYPES = {
    json: 'json',
};
